<template>
  <component :is="cmp" />
</template>

<script>
  export default {
    props: {
      cmp: {
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  svg.v-icon {
    fill: currentColor;
    -webkit-appearance: none;
  }
</style>